import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const updateInvoiceDetails = async (domain: string, invoiceName: string, invoiceCompanyNumber: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/invoice-details`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            invoiceName,
            invoiceCompanyNumber
        },
        domain,
    });
}